import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useClientApiFetch } from 'ts/client/common/hooks';
import ClientInvoiceOverview from 'ts/common/components/invoice/ClientInvoiceOverview';
import { FetchMethod } from 'ts/common/hooks';

const InvoiceLandingPage: React.FC = () => {
    const { invoice, refetchInvoice } =
        useOutletContext<{ invoice: SpApi.Client.IInvoice; refetchInvoice: () => Promise<void> }>();

    useEffect(() => {
        scrollTo(0, 0);
    }, []);

    const { performFetch: removeSavedCard } = useClientApiFetch<void>(
        `brand/${invoice.brand.id}/invoice/${invoice.publicId}/credit-card`,
        {
            defer: true,
            method: FetchMethod.DELETE
        }
    );

    const onRemoveSavedCard = async () => {
        const response = await removeSavedCard();
        await refetchInvoice();
        return response;
    };

    return <ClientInvoiceOverview invoice={invoice} onRemoveSavedCard={onRemoveSavedCard} />;
};

export default InvoiceLandingPage;
